import { Injectable } from '@angular/core';
import { Accordion } from 'primeng/accordion';
import { Dialog } from 'primeng/dialog';


@Injectable({
    providedIn: 'root'
})
export class UtilitiesPrimeNG {

    static toggleDialogMaximize(event, dialog: Dialog) {
        dialog.maximize();
        if (!dialog.maximized) {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            });
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 200);
        }
    }

    static toggleMaximize(dialog: Dialog) {

        dialog.maximize();

        if (dialog.maximized) {
            dialog.style = { width: '100vw', height: '100vh' };
        } else {
            dialog.style = { width: '80vw', height: '80vh' };
        }
    }

    static closeAllAccordionTabs(accordion: Accordion, excepts: number[] = null) {
        excepts = excepts || [];
        if (!!accordion && !!accordion.tabs) {
            for (let i = 0; i < accordion.tabs.length; i++) {
                const tab = accordion.tabs[i];
                if (excepts.indexOf(i) === -1) {
                    if (tab.selected) tab.selected = false;
                } else if (!tab.selected) {
                    tab.selected = true;
                }
            }
        }
    }

    static openAllAccordionTabs(accordion: Accordion, excepts: number[] = null) {
        if (!!accordion && !!accordion.tabs) {
            for (let i = 0; i < accordion.tabs.length; i++) {
                const tab = accordion.tabs[i];
                if (excepts.indexOf(i) === -1) {
                    if (!tab.selected) tab.selected = true;
                } else if (tab.selected) {
                    tab.selected = false;
                }
            }
        }
    }


}
